import { Component, Input, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CaseData } from 'src/app/models/case-data.model';
import { claimSumRemainingAmount } from 'src/types/claim-sum';

import { ActivatedRoute } from '@angular/router';
import { DecimalPipe, KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-full-payment',
  templateUrl: './full-payment.component.html',
  styleUrls: ['./full-payment.component.scss'],
  imports: [DecimalPipe, KeyValuePipe],
})
export class FullPaymentComponent {
  readonly claimSumRemainingAmount = claimSumRemainingAmount;

  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);

  @Input({ required: true }) caseData!: CaseData;

  readonly paymentForm = this.fb.group({
    aszf: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
    pp: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
  });

  keyId = this.route.snapshot.params['docID'] as string;

  async startPayment(): Promise<void> {
    throw new Error('Unimplemented');
  }
}
